import Swal from "sweetalert2";

export function absoluteUrl(relativeUrl) {
  return process.env.PUBLIC_URL + "/" + relativeUrl;
}

export const formatKey = (key) =>
  key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const renderStarIcon = (index, ratingValue) => {
  if (index <= ratingValue - 1) {
    return "star"; // Fully filled star
  } else if (index < ratingValue && ratingValue % 1 !== 0) {
    return "star_half"; // Half-filled star
  } else {
    return "star_border"; // Empty star
  }
};

export function splitTime(input) {
  if (input) {
    const hours = parseInt(input.split("H")[0]);
    const mins = parseInt(input.split(":")[1].split("M")[0]);
    return { hours, mins };
  }
}
export const extractAndConvertToPositive = (str) => {
  const match = str.match(/-?\d+/); // Match a number with optional negative sign
  return match ? Math.abs(Number(match[0])) : null; // Convert to positive number
};

export const transformKeys = (obj) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(),
      value,
    ])
  );

export const toSnakeCase = (key) => {
  return key.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
};

export function removeCountryCode(phoneNumber) {
  return phoneNumber?.replace(/^\+?\d{1,3}/, "")?.trim();
}

export const copyToClipboard = (link) => {
  navigator.clipboard.writeText(link).catch((err) => {
    Swal.fire({
      icon: "error",
      title: "Failed to copy the link: ",
      err,
    });
  });
};
export const formatDate = (date) => {
  if (date) return date.toISOString().split("T")[0]; // Extracts YYYY-MM-DD
};

export const convertBooleanValues = (arr, keysToConvert) => {
  return arr.map((item) => ({
    ...item,
    ...Object.fromEntries(
      keysToConvert.map((key) => [key, item[key] === 1 ? "Yes" : "No"])
    ),
  }));
};

export const getTotalMinutes = (duration) => {
  const match = duration?.match(/(\d+)H:(\d+)M/); // Extract hours and minutes
  if (!match) return 0; // Return 0 if the format is incorrect

  const hours = parseInt(match[1], 10); // Convert hours to number
  const minutes = parseInt(match[2], 10); // Convert minutes to number

  return hours * 60 + minutes; // Convert hours to minutes and add
};

export const formatLabel = (str) => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (s) => s.toUpperCase())
    .replace(/\b\w/g, (s) => s.toUpperCase());
};

export function formatDateForChat(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (date.toDateString() === now.toDateString()) {
    // If the date is today
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } else if (date.toDateString() === yesterday.toDateString()) {
    // If the date is yesterday
    return "Yesterday";
  } else {
    // If the date is more than yesterday
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }
}
